<template>
    <div class="container-main">
        <div class="main-header-buttons">
            <v-btn @click="back" style="width: auto !important" class="button-accept">
                <v-icon>mdi-chevron-left</v-icon>
                Вернуться к списку рассылок
            </v-btn>
            <div class="main-header-text">
                <div class="main-header-text-item">
                    <div>
                        Название события:
                    </div>
                    <div>
                        {{ event.name }}
                    </div>

                </div>
                <div class="main-header-text-item">
                    <div>
                        id:
                    </div>
                    <div>
                        {{ event.id }}
                    </div>

                </div>


            </div>
            <!-- <div>
                <v-btn outlined color="var(--app-dark-blue-1)" 
                 style="width: auto !important; margin-right: 20px"
                  class="button-accept-outlined" @click="getTable">
                    Скачать список участников 
                </v-btn>
                <v-btn @click="goToEdit" style="width: auto !important" class="button-action">
                    Редактировать
                </v-btn>
            </div> -->

        </div>

        <div>

            <v-data-table :headers="tableHeaders" :items="letters"
                :footer-props="{ itemsPerPageOptions: [10, 25, 50], 'items-per-page-text': '' }"
                class="elevation-0 main-table" :items-per-page="optionTable.itemsPerPage" :page="optionTable.page"
                :server-items-length="optionTable.serverItemsLength" @pagination="tableChange" fixed-header>

                <template v-slot:body="props">
                    <tbody>
                        <tr v-for="(item, index) in props.items" :key="index">

                            <td>{{ item.id }}</td>

                            <td>
                                {{ item.email }}
                            </td>
                            <td>
                                <div v-if="item.status == 'not_sent'">
                                    Не отправленно
                                </div>
                                <div v-else-if="item.status == 'error'">
                                    Ошибка
                                </div>
                                <div v-else-if="item.status == 'sent'">
                                    Отправленно
                                </div>

                            </td>
                            <td>
                                {{ item.error }}
                            </td>

                            <td>
                                {{ item.dateCreated | moment(" HH:mm DD.MM.YYYY ") }}

                            </td>
                            <td>
                                {{ item.dateUpdated | moment(" HH:mm DD.MM.YYYY ") }}
                            </td>
                            <td>
                                <v-btn @click="pushLetter(item)" :loading="push == item.id" :disabled="push == item.id"
                                    style="width: auto !important" class="button-accept">
                                    Отправить
                                </v-btn>

                            </td>

                        </tr>
                    </tbody>
                </template>

            </v-data-table>
        </div>


    </div>
</template>
<script>


export default {

    data: () => ({
        push: null,
        letters: [],
        event: {},
        tableHeaders: [
            {
                text: 'ID ',
                sortable: false,
            },

            {
                text: 'Email пользователя',
                sortable: false,

            },
            {
                text: 'Статус',
                sortable: false,

            },
            {
                text: 'Ошибка',
                sortable: false,

            },
            {
                text: 'Дата создания',
                sortable: false,

            },
            {
                text: 'Дата обновления',
                sortable: false,
            },
            {
                text: '',
                sortable: false,
            },

        ],
        optionTable: {
            page: 1,
            itemsPerPage: 10,
            serverItemsLength: -1
        },

    }),
    methods: {
        getEvent() {
            this.$axios.get(this.$store.getters.apiAdminPanelV2 + '/event', {
                headers: {
                    'authorization': this.$store.getters.adminPanelHeaderAuth
                },
                params: {
                    eventId: this.$route.params.id
                }
            })
                .then(res => {
                    this.event = res.data


                })
                .catch(err => {
                    this.$store.commit('errorSet', true)
                    this.$store.commit('errorTextSet', err)
                })

        },
        getTable() {

            this.$axios.post(this.$store.getters.apiAdminPanelV2 + '/event/registration/list', {
                eventId: this.$route.params.id,
                optionTable: this.optionTable,

            }, {
                headers: {
                    'authorization': this.$store.getters.adminPanelHeaderAuth
                }
            })
                .then(res => {
                    this.letters = res.data.items
                    this.optionTable = res.data.optionTable


                })
                .catch(err => {
                    this.$store.commit('errorSet', true)
                    this.$store.commit('errorTextSet', err)
                })
        },
        tableChange(data) {

            this.optionTable.page = data.page
            this.optionTable.itemsPerPage = data.itemsPerPage
            this.getTable()
        },

        back() {
            this.$router.push({ name: 'LettersEvents' })
        },

        pushLetter(item) {
            this.push = item.id
            this.$axios.get(this.$store.getters.apiAdminPanelV2 + '/event/registration/send', {
                headers: {
                    'authorization': this.$store.getters.adminPanelHeaderAuth
                },
                params: {
                    registrationId: item.id
                }
            })
                .then(res => {
                    this.event = res.data
                    setTimeout(() => {
                        this.push = null
                    }, 1000)

                })
                .catch(err => {
                    this.$store.commit('errorSet', true)
                    this.$store.commit('errorTextSet', err)
                    setTimeout(() => {
                        this.push = null
                    }, 1000)
                })

        },

    },
    created() {
        this.getTable()
        this.getEvent()

    }
}
</script>
<style lang="scss" scoped>
.container-main {
    box-sizing: border-box;
    padding: 40px 40px 0 40px;

    .main-header-buttons {
        display: flex;
        justify-content: space-between;
        margin-bottom: 40px;
    }

    .main-header-text {
        .main-header-text-item {
            display: flex;

            :first-child {
                font-size: 20px;
                font-weight: 400;
            }

            :last-child {
                font-size: 20px;
                font-weight: 600;
                margin-left: 20px;
            }
        }
    }

    .main-table {
        height: calc(100vh - 190px) !important;
        min-height: calc(100vh - 190px) !important;
        max-height: calc(100vh - 190px) !important;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

    }

}
</style>